import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";
import { SearchService } from '../../services/Search/search.service';

@Component({
  selector: 'app-search-image-rotator',
  imports: [
    CommonModule,
    MatIconModule
],
  templateUrl: './search-image-rotator.component.html',
  styleUrl: './search-image-rotator.component.scss'
})
export class SearchImageRotatorComponent {
@Input('pageBgList') pageBgList : any[] = [] ;
    public activeIndex: number = 0 
    private timeoutId : any

    constructor(
        public searchService: SearchService
    ) {
        this.loop()
    }

    ngOnDestroy() {
        clearTimeout(this.timeoutId)
    }

    loop() {
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
            this.next()
            this.loop()
        }, 5000);
    }

    next() {
        this.loop()
        if(this.activeIndex < this.pageBgList.length-1 ) {
            this.activeIndex++
        }
        else {
            this.activeIndex = 0
        }
    }

    prev() {
        this.loop()
        if(this.activeIndex - 1 > -1 ) {
            this.activeIndex--
        }
        else {
            this.activeIndex = this.pageBgList.length-1 
        }
    }

    search(text: string) {
        
            this.searchService.searchText = text;
            this.searchService.forceSearch$.next(text)
            // this.router.navigate(['/search']);
        
    }
}
